import cfeLogo from "../assets/portfolio-logos/cfe-logo.png";
import schneiderElectricLogo from "../assets/portfolio-logos/Schneider_Electric-Logo.png";

// Schneider Electric
import studyCaseSchneider1 from "../assets/portfolio-images/schneider-electric/studyCaseSchneider1.webp";
import studyCaseSchneider2 from "../assets/portfolio-images/schneider-electric/studyCaseSchneider2.webp";
import studyCaseSchneider3 from "../assets/portfolio-images/schneider-electric/studyCaseSchneider3.webp";

// CFE
import studyCaseCFE1 from "../assets/portfolio-images/cfe/studyCaseCFE1.webp";
import studyCaseCFE2 from "../assets/portfolio-images/cfe/studyCaseCFE2.webp";
import studyCaseCFE3 from "../assets/portfolio-images/cfe/studyCaseCFE3.webp";

export const brands = [
  // Español
  [
    {
      logo: cfeLogo,
      name: "Comisión Federal De Electricidad",
      buttonMainPage: "Ver caso de Éxito",
      industry: "Energía",
      projects: [
        {
          name: "Plataforma de Monitoreo Energético para la Comisión Federal de Electricidad (CFE)",
          client: "Comisión Federal De Electricidad",
          industry: "Energía",
          services: "Desarrollo de Plataformas de Datos e Integración",
          caseStudy: [
            {
              title: "Desafío del Cliente",
              description:
                "La Comisión Federal de Electricidad (CFE) requería una solución tecnológica que le permitiera centralizar, estructurar y consultar información técnica proveniente de múltiples fuentes distribuidas a lo largo del país. El objetivo era mejorar la eficiencia operativa, reducir la intervención manual y asegurar la integridad y disponibilidad de los datos técnicos bajo estrictos lineamientos de confidencialidad.",
              image: studyCaseCFE1,
            },
            {
              title: "Nuestra Solución",
              description:
                "Greedy diseñó una arquitectura modular compuesta por APIs desarrolladas en Node.js, procesamiento distribuido mediante RabbitMQ, almacenamiento intermedio con Redis y una base de datos relacional optimizada en MariaDB. La solución fue estructurada en etapas para garantizar escalabilidad, trazabilidad y alto rendimiento, adaptándose completamente a los flujos operativos y requisitos internos de la CFE.",
              image: studyCaseCFE2,
            },
            {
              title: "Resultados que Generan Valor",
              description:
                "La plataforma permitió automatizar procesos clave, mejorar el acceso a la información técnica y optimizar la gestión de grandes volúmenes de datos. Asimismo, fortaleció la capacidad operativa de la CFE al proporcionar una base sólida para análisis estratégicos y futuras integraciones tecnológicas a nivel nacional.",
              image: studyCaseCFE3,
            },
          ],
        },
      ],
    },
    {
      logo: schneiderElectricLogo,
      name: "Schneider Electric",
      buttonMainPage: "Ver caso de Éxito",
      industry: "Energía",
      projects: [
        {
          name: "Torque Tracker para Schneider Electric",
          client: "Schneider Electric",
          industry: "Energía",
          services: "Desarrollo de Software Empresarial a la Medida",
          caseStudy: [
            {
              title: "Desafío del Cliente",
              description:
                "Schneider Electric, un líder global en gestión de energía y automatización, enfrentaba una necesidad crítica: establecer una herramienta robusta y confiable para registrar, organizar y consultar en tiempo real los aprietes de torque realizados durante sus complejos procesos de producción. La ausencia de una trazabilidad centralizada y precisa no solo impactaba la calidad del producto, sino que también complicaba las auditorías internas y externas, y obstaculizaba la eficiencia operativa.",
              image: studyCaseSchneider1,
            },
            {
              title: "Nuestra Solución",
              description:
                "Greedy diseñó e implementó un sistema de gestión de aprietes completamente local, asegurando así el control total de los datos y la máxima seguridad. Esta solución integral abarcó el desarrollo de una API personalizada y un panel de control web intuitivo, optimizados para el uso en planta. Para manejar eficientemente grandes volúmenes de datos, integramos una base de datos de alto rendimiento y un sistema de almacenamiento en memoria. Nuestra prioridad fue la estabilidad, la velocidad de acceso a la información y la facilidad de uso para el personal técnico, garantizando una adopción fluida y sin interrupciones.",
              image: studyCaseSchneider2,
            },
            {
              title: "Resultados que Generan Valor",
              description:
                "El sistema Torque Tracker ha transformado la gestión de la calidad en Schneider Electric. Ahora cuentan con una plataforma local centralizada que no solo organiza y almacena registros de eventos clave en su línea de producción, sino que también mejora drásticamente la capacidad de análisis de datos. Esto ha culminado en una mayor consistencia en la calidad del producto, una simplificación notable de los procesos de auditoría y ha establecido una base sólida para el mantenimiento proactivo de los estándares de producción.",
              image: studyCaseSchneider3,
            },
          ],
        },
      ],
    },
  ],
  // Ingles
  [
    {
      logo: cfeLogo,
      name: "Comisión Federal De Electricidad",
      buttonMainPage: "View Success Story",
      industry: "Energy",
      projects: [
        {
          name: "Energy Monitoring Platform for the Comisión Federal De Electricidad (CFE)",
          client: "Comisión Federal De Electricidad",
          industry: "Energy",
          services: "Data Platform and Integration Development",
          caseStudy: [
            {
              title: "Client's Challenge",
              description:
                "The Comisión Federal De Electricidad (CFE) required a technological solution to centralize, structure, and consult technical information from multiple sources distributed throughout the country. The objective was to improve operational efficiency, reduce manual intervention, and ensure the integrity and availability of technical data under strict confidentiality guidelines.",
              image: studyCaseCFE1,
            },
            {
              title: "Our Solution",
              description:
                "Greedy designed a modular architecture composed of APIs developed in Node.js, distributed processing using RabbitMQ, intermediate storage with Redis, and an optimized relational database in MariaDB. The solution was structured in stages to ensure scalability, traceability, and high performance, fully adapting to CFE's operational flows and internal requirements.",
              image: studyCaseCFE2,
            },
            {
              title: "Value-Generating Results",
              description:
                "The platform allowed for the automation of key processes, improved access to technical information, and optimized the management of large volumes of data. It also strengthened CFE's operational capacity by providing a solid foundation for strategic analysis and future technological integrations at a national level.",
              image: studyCaseCFE3,
            },
          ],
        },
      ],
    },
    {
      logo: schneiderElectricLogo,
      name: "Schneider Electric",
      buttonMainPage: "View Success Story",
      industry: "Energy",
      projects: [
        {
          name: "Torque Tracker for Schneider Electric",
          client: "Schneider Electric",
          industry: "Energy",
          services: "Custom Enterprise Software Development",
          caseStudy: [
            {
              title: "Client's Challenge",
              description:
                "Schneider Electric, a global leader in energy management and automation, faced a critical need: to establish a robust and reliable tool to record, organize, and consult in real-time the torque tightenings performed during its complex production processes. The lack of centralized and precise traceability not only impacted product quality but also complicated internal and external audits and hindered operational efficiency.",
              image: studyCaseSchneider1,
            },
            {
              title: "Our Solution",
              description:
                "Greedy designed and implemented a completely local tightening management system, thus ensuring full data control and maximum security. This comprehensive solution included the development of a custom API and an intuitive web control panel, optimized for plant use. To efficiently handle large volumes of data, we integrated a high-performance database and an in-memory storage system. Our priority was stability, speed of access to information, and ease of use for technical staff, ensuring a smooth and seamless adoption.",
              image: studyCaseSchneider2,
            },
            {
              title: "Value-Generating Results",
              description:
                "The Torque Tracker system has transformed quality management at Schneider Electric. They now have a centralized local platform that not only organizes and stores records of key events in their production line but also drastically improves data analysis capabilities. This has resulted in greater consistency in product quality, a notable simplification of audit processes, and has established a solid foundation for proactive maintenance of production standards.",
              image: studyCaseSchneider3,
            },
          ],
        },
      ],
    },
  ],
];
